// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__4zmlP","inputWrapper":"Contact_inputWrapper__aDjBJ","flash":"Contact_flash__AuuVW"};